import { useState } from "react";
import type { SettingsResponse } from "../../shared/types";
import { api } from "../lib/api";
import { type Colours, lookOf } from "./looks";
import type { LookMode } from "./parts";
import type { Run } from "./useSettingsData";

/** The look being chosen in setup: saving the colours is choosing the look, as the server marks the step done with them. */
export function useLookChoice(data: SettingsResponse, run: Run) {
  const [colours, setColours] = useState<Colours>({ accent: data.brand.accent, brass: data.brand.brass, paper: data.brand.paper });
  const [mode, setMode] = useState<LookMode>(() => lookOf(data.brand));
  const [saving, setSaving] = useState(false);
  const save = async (): Promise<boolean> => {
    setSaving(true);
    const ok = await run(() => api.settings.updateBrand(colours));
    setSaving(false);
    return ok;
  };
  return {
    colours,
    mode,
    saving,
    save,
    pick: (m: LookMode, c: Colours) => {
      setMode(m);
      setColours(c);
    },
  };
}
